/**
 * WalterGO Blog Post – Interactive Enhancements
 * ==============================================
 * Läuft nur auf article.beitrag-Template.
 * Kein externes Dependency – Vanilla JS, < 2 KB minifiziert.
 *
 * Features:
 *   1. Inhaltsverzeichnis aus h2[id] + h3[id] generieren
 *   2. Ersten <p> nach H1 als .intro-text stylen
 *   3. FAQPage-JSON-LD aus FAQ <details> (.waltergo-faq) generieren
 */

(function () {
  'use strict';

  const article = document.querySelector('.article-template');
  if (!article) return;

  const content = article.querySelector('.article-template__content');
  if (!content) return;

  /* ================================================================
   * 1. Inhaltsverzeichnis (ToC)
   * ================================================================
   * Scannt h2[id] und h3[id] im Content. Baut Navigation mit Anker-Links.
   * Google parsed diese Links als Sitelinks in der SERP.
   */
  function buildTableOfContents() {
    const headings = content.querySelectorAll('h2[id], h3[id]');
    if (headings.length < 2) return; // Mindestens 2 für sinnvolles ToC

    const toc = document.createElement('nav');
    toc.className = 'waltergo-toc';
    toc.setAttribute('aria-label', 'Inhaltsverzeichnis');

    const tocTitle = document.createElement('div');
    tocTitle.className = 'toc-title';
    tocTitle.innerHTML = '<span>📖</span> Inhaltsverzeichnis';
    toc.appendChild(tocTitle);

    const list = document.createElement('ul');
    let counter = 0;

    headings.forEach(function (h) {
      counter++;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = counter + '. ' + h.textContent.trim();

      // h3 bekommt Einrückung
      if (h.tagName === 'H3') {
        li.style.paddingLeft = '20px';
        li.style.fontSize = '14px';
        a.textContent = h.textContent.trim(); // h3 ohne Nummerierung
      }

      li.appendChild(a);
      list.appendChild(li);
    });

    toc.appendChild(list);

    // ToC nach dem ersten <p> im Content einfügen
    const firstP = content.querySelector('p');
    if (firstP && firstP.nextElementSibling) {
      firstP.parentNode.insertBefore(toc, firstP.nextElementSibling);
    } else {
      content.insertBefore(toc, content.firstChild);
    }
  }

  /* ================================================================
   * 2. Intro-Text
   * ================================================================
   * Erster <p> nach H1 bekommt .intro-text (fette Einleitung).
   */
  function styleIntro() {
    const firstP = content.querySelector('p');
    if (!firstP) return;

    // Nur stylen, wenn der Artikel mehr als nur diesen Paragraf hat
    const allP = content.querySelectorAll('p');
    if (allP.length >= 2) {
      firstP.classList.add('intro-text');
    }
  }

  /* ================================================================
   * 3. Auto-IDs für H2/H3 ohne ID
   * ================================================================
   * Stellt sicher, dass alle H2/H3 eine ID haben (für ToC-Links).
   */
  function ensureHeadingIDs() {
    const headings = content.querySelectorAll('h2, h3');
    const usedIDs = new Set();

    headings.forEach(function (h) {
      if (h.id && h.id.trim() !== '') {
        usedIDs.add(h.id);
        return;
      }

      // Slug aus Text generieren
      let slug = h.textContent
        .trim()
        .toLowerCase()
        .replace(/[ä]/g, 'ae')
        .replace(/[ö]/g, 'oe')
        .replace(/[ü]/g, 'ue')
        .replace(/[ß]/g, 'ss')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .substring(0, 60);

      // Kollisionen vermeiden
      let unique = slug;
      let suffix = 1;
      while (usedIDs.has(unique)) {
        unique = slug + '-' + suffix;
        suffix++;
      }

      h.id = unique;
      usedIDs.add(unique);
    });
  }

  /* ================================================================
   * 4. FAQPage-Schema aus FAQ-<details>
   * ================================================================
   * Liest den FAQ-Block (.waltergo-faq > details mit <summary>Frage</summary>)
   * und injiziert FAQPage-JSON-LD in <head>. Google rendert und liest dieses
   * Schema. Ohne FAQ-Block passiert nichts.
   */
  function buildFaqSchema() {
    const faq = content.querySelector('.waltergo-faq');
    if (!faq) return;

    const items = faq.querySelectorAll('details');
    if (!items.length) return;

    const mainEntity = [];
    items.forEach(function (item) {
      const summary = item.querySelector('summary');
      if (!summary) return;
      const question = summary.textContent.trim();

      // Antwort = gesamter Text des <details> ohne die <summary>
      const clone = item.cloneNode(true);
      const s = clone.querySelector('summary');
      if (s) s.remove();
      const answer = clone.textContent.replace(/\s+/g, ' ').trim();

      if (question && answer) {
        mainEntity.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: { '@type': 'Answer', text: answer }
        });
      }
    });

    if (!mainEntity.length) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: mainEntity
    });
    document.head.appendChild(script);
  }

  /* ================================================================
   * Start
   * ================================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    ensureHeadingIDs();
    styleIntro();
    buildTableOfContents();
    buildFaqSchema();
  }
})();
